import React, { useState } from "react";
import {
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import styles from "./RsvpAddress.module.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import GoogleMap from "../../../../components/GoogleMap/GoogleMap";
import { useLocation, useNavigate } from "react-router-dom";
import { LocIcon } from "../../../../components/icons/Icons";
import { Col, Row } from "antd";
import AutoCompleteInput from "../../../../components/auntoCompleteInput/AutoCompleteInput";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";

const RsvpAddress = () => {
  const { state } = useLocation();
  const eventData = state?.eventData;
  const [currentLocation, setCurrentLocation] = useState();
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const [address, setaddress] = useState(
    RSVP.address?.address
      ? RSVP.address?.address
      : eventData?.address
      ? eventData?.address
      : ""
  );
  const [lat, setlat] = useState(
    RSVP.address?.lat
      ? `${RSVP.address?.lat}`
      : eventData?.lat
      ? `${eventData?.lat}`
      : 37.78825
  );
  const [lng, setlng] = useState(
    RSVP.address?.lng
      ? `${RSVP.address?.lng}`
      : eventData?.lng
      ? `${eventData?.lng}`
      : -122.4324
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const next = () => {
    if (!address || !lat || !lng) {
      dispatch(
        showAlert({
          type: "Error",
          title: "Address",
          message: "Please add event address.!",
          status: 400,
        })
      );
      return;
    } else {
      let resdata = {
        ...RSVP,
        address: {
          address,
          lat,
          lng,
        },
      };
      dispatch(setRSVP(resdata));
      navigate("/events/rsvp/qa", {
        state: { headrTitle: "Q/A", eventData: eventData },
      });
    }
  };
  return (
    <div>
      <TextHeader
        text={"7. Address"}
        containerClass={styles.textContainer}
        textClass={styles.textHeading}
      />
      {/* <div className={styles.mainInput}> */}
      <AutoCompleteInput
        label={"Address"}
        placeholder={"Enter Adress"}
        address={currentLocation?.address}
        onSelectPlace={(place) => {
          let currentLocation = {
            lat: place?.geometry?.location?.lat(),
            lng: place?.geometry?.location?.lng(),
            address: place?.formatted_address,
          };
          setCurrentLocation(currentLocation);
          setaddress(currentLocation?.address);
          setlat(currentLocation?.lat);
          setlng(currentLocation?.lng);
        }}
      />
      {/* <LocIcon className={styles.icon} size={20} />
      </div> */}
      <GoogleMap
        style={{ marginLeft: "10px", marginRight: 0 }}
        lat={lat}
        lng={lng}
      />
      <Row gutter={[16, 16]} className={styles.btnRow}>
        <Col xs={24} sm={12} md={10} lg={8} xl={7}>
          <SubmitButton
            btnClass={styles.btnClass}
            title="Next"
            onClick={next}
          />
        </Col>
      </Row>
    </div>
  );
};

export default RsvpAddress;
